import React, { useState, useEffect } from "react";
import axios from "axios";
import Chart from "chart.js/auto";
import { Bar, Line } from "react-chartjs-2";
import { Pie, Doughnut } from "react-chartjs-2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Spinner";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import PersonIcon from "@mui/icons-material/Person";
import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";
import RouteIcon from "@mui/icons-material/Route";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import LoopIcon from "@mui/icons-material/Loop";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarViewDayIcon from "@mui/icons-material/CalendarViewDay";
import DateRangeIcon from "@mui/icons-material/DateRange";
import GroupIcon from "@mui/icons-material/Group";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocationOffIcon from "@mui/icons-material/LocationOff";
import { Tabs, Tab, Box } from "@mui/material";
import { FaExchangeAlt, FaSpinner, FaCheck, FaUsers } from "react-icons/fa"; // Import the desired icons from a library like react-icons
import { format } from "date-fns";
import { TripRevenueTab } from "./tabs/TripRevenueTab";
import { TabPanel } from "./TabPanel";
import { PassengerDriverTab } from "./tabs/PassengerDriverTab";
import GeneralStatistics from "./tabs/GeneralStatistics";
import AmbulanceStatistics from "./tabs/EmergencyCard";
const Dashboard = () => {
  const [dashboard, setDashboard] = useState("");
  const [allDashboardData, setAllDashboardData ] = useState({})
  const [driversByGender, setDriversByGender] = useState();
  const [driversByMonth, setDriversByMonth] = useState();
  const [driversByRegistration, setDriversByRegistration] = useState();
  const [passengersByMonth, setPassengersByMonth] = useState();
  const [passengersByGender, setPassengersByGender] = useState();
  const [tripsByMonth, setTripsByMonth] = useState();
  const [revenuesByMonth, setrevenuesByMonth] = useState();
  const [activeDriversCount, setActiveDriversCount] = useState();
  const [dailyTripsCount, setDailyTripsCount] = useState();
  const [dailyTripRequestsCount, setDailyTripRequestsCount] = useState();
  const [dailyAcceptedTripRequestsCount, setDailyAcceptedTripsCount] =
    useState();
   const [dailyPendingTripRequestsCount, setDailyPendinngTripsCount] =
    useState();
  const [dailySharedTripsCount, setDailySharedTripsCount] = useState();
  const [dailyOneTouchRequestsCount, setDailyOneTouchRequestsCount] =
    useState();

  const [dailyNewDriversCount, setDailyNewDriversCount] = useState();
  const [dailyNewPassengersCount, setDailyNewPassengersCount] = useState();
  const [dailyRevenue, setDailyRevenue] = useState();
  const [weeklyRevenue, setWeeklyRevenue] = useState(0);
  const [monthlyRevenue, setMonthlyRevenue] = useState();
  const [yearlyRevenue, setYearlyRevenue] = useState();
  const [trendingPickupLocations, setTrendingPickUpLocations] = useState();
  const [trendingDestinationLocations, setTrendingDestinationLocations] =
    useState();
  let [loading, setLoading] = useState(true);

  // data

  const iconSize = 50;
  useEffect(() => {
    getAllDashboardData();
    getDashboard();
    getDriversByGender();
    getDriversByMonth();
    getDriversByRegistration();
    getPassengersByMonth();
    getPassengersByGender();
    getTripsByMonth();
    getRevenuesByMonth();
    getActiveDriversCount();
    getDailyTripsCount();
    getDailyTripRequestsCount();
    getDailyAcceptedTripRequestsCount();
    getDailyPendingRequestsCount();
    getDailySharedTripsCount();
    getDailyOneTouchRequestsCount();
    getDailyNewPassengersCount();
    getDailyNewDriversCount();
    getDailyRevenue();
    getWeeklyRevenue();
    getMonthlyRevenue();
    getYearlyRevenue();
    getTrendingPickUpLocations();
    getTrendingDestinationLocations();

  }, []);


  const fetchData = async (url, setter, notifyMessage) => {
    try {
      const token = localStorage.getItem("d4uToken");
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setter(response.data);
      setLoading(false);
      notify(notifyMessage);
    } catch (err) {
      notifyError();
    }
  };



  const smallBoxStyle = {
    backgroundColor: "#4D0A99",
  };

  const numberStyle = {
    color: "rgb(77, 10, 153)",
    // maxWidth: "100px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: 20,
  };

  const iconStyle = {
    color: "white",
    fontSize: 50,
  };

  const textStyle = {
    color: "white",
    fontSize: 16,
  };

  
  const getDashboard = () => fetchData("/dashboard", setDashboard, "Dashboard");
const getDriversByGender = () =>
  fetchData("/driversByGender", setDriversByGender, "Driver by gender");
const getPassengersByGender = () =>
  fetchData("/passengersByGender", setPassengersByGender, "Passenger by gender");
const getDriversByMonth = () =>
  fetchData("/driversByMonth", setDriversByMonth, "Driver by month");
const getDriversByRegistration = () =>
  fetchData("/driversByRegistration", setDriversByRegistration, "Driver by registration");
const getPassengersByMonth = () =>
  fetchData("/passengersByMonth", setPassengersByMonth, "Passengers by month");
const getTripsByMonth = () =>
  fetchData("/tripsByMonth", setTripsByMonth, "Trips by month");
const getRevenuesByMonth = () =>
  fetchData("/revenueByMonth", setrevenuesByMonth, "Revenue by month");
const getActiveDriversCount = () =>
  fetchData("/activeDriversCount", setActiveDriversCount, "Active drivers");
const getDailyTripsCount = () =>
  fetchData("/dailyTripsCount", setDailyTripsCount, "Daily trip count");
const getDailyTripRequestsCount = () =>
  fetchData("/dailyTripRequestsCount", setDailyTripRequestsCount, "Daily trip request");
const getDailyAcceptedTripRequestsCount = () =>
  fetchData("/dailyAcceptedTripRequestsCount", setDailyAcceptedTripsCount, "Daily accepted trip");
const getDailyPendingRequestsCount = () =>
  fetchData("/dailyPendingTripRequestsCount", setDailyPendinngTripsCount, "Daily pending trips");
const getDailySharedTripsCount = () =>
  fetchData("/dailySharedTripsCount", setDailySharedTripsCount, "Daily shared trips");
const getDailyOneTouchRequestsCount = () =>
  fetchData("/dailyOneTouchRequestsCount", setDailyOneTouchRequestsCount, "Daily one touch");
const getDailyNewDriversCount = () =>
  fetchData("/dailyNewDriversCount", setDailyNewDriversCount, "Daily new driver");
const getDailyNewPassengersCount = () =>
  fetchData("/dailyNewPassengersCount", setDailyNewPassengersCount, "Daily new passenger");
const getDailyRevenue = () =>
  fetchData("/dailyRevenue", setDailyRevenue, "Daily revenue");
const getWeeklyRevenue = () =>
  fetchData("/weeklyRevenue", (data) => setWeeklyRevenue(data[0].amount), "Weekly revenue");
const getMonthlyRevenue = () =>
  fetchData("/monthlyRevenue", setMonthlyRevenue, "Monthly revenue");
const getYearlyRevenue = () =>
  fetchData("/yearlyRevenue", setYearlyRevenue, "Yearly Revenue");
const getTrendingPickUpLocations = () =>
  fetchData("/trendingPickUpLocations", setTrendingPickUpLocations, "Trending pickup");
const getTrendingDestinationLocations = () =>
  fetchData("/trendingDestinationLocations", setTrendingDestinationLocations, "Trending Destination");
// here is now
const getAllDashboardData = () => fetchData("/dashboard-data", setAllDashboardData, "")

  const notify = (message) =>
    toast.success(`${message} list loaded.`, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  const driversByMonthLabels = [];

  const driversByMonthCount = [];
  if (driversByMonth !== undefined) {
    // console.log("llll", driversByMonth);
    driversByMonth.forEach((driverByMonth) => {
      driversByMonthLabels.push(driverByMonth.month);
      driversByMonthCount.push(driverByMonth.count);
    });
  }

  const driversByRegistrationLabel = ["Agent", "SubAgent", "Self"];
  let driversByRegistrationD = [];

  if (driversByRegistration !== undefined) {
    driversByRegistrationD = [
      driversByRegistration.byAgent,
      driversByRegistration.bySubAgent,
      driversByRegistration.bySelf,
    ];
  }

  const driversByMonthData = {
    labels: driversByMonthLabels,
    datasets: [
      {
        label: "Drivers By Month",
        backgroundColor: "#4D0A99",
        borderColor: "rgba(0,0,0,1)",
        borderWidth: 1,
        data: driversByMonthCount,
      },
    ],
  };

  const driversByRegistrationData = {
    labels: driversByRegistrationLabel,
    datasets: [
      {
        label: "Drivers",
        data: driversByRegistrationD,
        backgroundColor: [
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(75, 192, 192, 0.6)",
        ],
      },
    ],
  };

  const passengersByMonthLabels = [];
  const passengersByMonthCount = [];
  if (passengersByMonth !== undefined) {
    // console.log("llll", passengersByMonth);
    passengersByMonth.forEach((passengerByMonth) => {
      passengersByMonthLabels.push(passengerByMonth.month);
      passengersByMonthCount.push(passengerByMonth.count);
    });
  }

  const passengersByMonthData = {
    labels: passengersByMonthLabels,
    datasets: [
      {
        label: "Passengers By Month",
        backgroundColor: "#4D0A99",
        borderColor: "rgba(0,0,0,1)",
        borderWidth: 2,
        data: passengersByMonthCount,
      },
    ],
  };

  const driversByGenderLabels = [];
  const driversByGenderCount = [];

  if (driversByGender !== undefined) {
    driversByGender.forEach((driverByGender) => {
      driversByGenderLabels.push(driverByGender.gender);
      driversByGenderCount.push(driverByGender.count);
    });
  }

  const driversByGenderData = {
    labels: driversByGenderLabels,
    datasets: [
      {
        label: "Drivers By Gender",
        backgroundColor: [
          "#B21F00",
          "#C9DE00",
          "#2FDE00",
          "#00A6B4",
          "#6800B4",
        ],
        hoverBackgroundColor: [
          "#501800",
          "#4B5000",
          "#175000",
          "#003350",
          "#35014F",
        ],
        data: driversByGenderCount,
      },
    ],
  };

  const passengersByGenderLabels = [];
  const passengersByGenderCount = [];

  if (passengersByGender !== undefined) {
    passengersByGender.forEach((passengerByGender) => {
      passengersByGenderLabels.push(passengerByGender.gender);
      passengersByGenderCount.push(passengerByGender.count);
    });
  }

  const passengersByGenderData = {
    labels: passengersByGenderLabels,
    datasets: [
      {
        label: "Passengers By Gender",
        backgroundColor: [
          "#B21F00",
          "#C9DE00",
          "#2FDE00",
          "#00A6B4",
          "#6800B4",
        ],
        hoverBackgroundColor: [
          "#501800",
          "#4B5000",
          "#175000",
          "#003350",
          "#35014F",
        ],
        data: passengersByGenderCount,
      },
    ],
  };

  const tripsByMonthLabels = [];
  const tripsByMonthCount = [];

  if (tripsByMonth !== undefined) {
    tripsByMonth.forEach((tripByMonth) => {
      tripsByMonthLabels.push(tripByMonth.month);
      tripsByMonthCount.push(tripByMonth.count);
    });
  }

  const tripsByMonthData = {
    labels: tripsByMonthLabels,
    datasets: [
      {
        label: "Trips By Date",
        fill: true,
        lineTension: 0.5,
        backgroundColor: "#A2158D",
        borderColor: "#198754",
        borderWidth: 2,
        data: tripsByMonthCount,
      },
    ],
  };

  const revenuesByMonthLabels = [];
  const revenuesByMonthCount = [];

  if (revenuesByMonth !== undefined) {
    revenuesByMonth.forEach((revenueByMonth) => {
      if (revenueByMonth.total_amount != null) {
        revenuesByMonthLabels.push(
          format(new Date(revenueByMonth.createdAt), "p, dd/MM/yyyy")
        );
        revenuesByMonthCount.push(revenueByMonth.total_amount);
      }
    });
  }

  const revenuesByMonthData = {
    labels: revenuesByMonthLabels,
    datasets: [
      {
        label: "Revenues By Date",
        fill: true,
        lineTension: 0.5,
        backgroundColor: "#A2158D",
        borderColor: "#198754",
        borderWidth: 2,
        data: revenuesByMonthCount,
      },
    ],
  };
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };



  const dashboardData = {
    activeAmbulances: allDashboardData?.active_ambulance || 0,
    availableAmbulances: allDashboardData?.totalAmbulances || 0,
    emergencyCalls: allDashboardData?.emergency_trips || 0,
    nonEmergencyCalls: allDashboardData?.non_emergency_trips || 0,
    criticalCases: allDashboardData?.cases?.severe_severity || 0,
    mildCases: allDashboardData?.cases?.mild_severity || 0,
    moderateCases: allDashboardData?.cases?.moderate_severity || 0,
    specialityCategory : allDashboardData?.speciality_category || {},
    pendingCalls: 0,
    avgResponseTime: 8.5,
    successRate: 94,
    connectedHospitals: 28,
    totalAmbulances: 60,
    medicalStaff: 156,
    coverageArea: allDashboardData?.actual_total_distance|| 0,
    responseRate: 97,
    urbanResponseTime: 7,
    suburbanResponseTime: 12,
    ruralResponseTime: 18,
    totalStaff: 200,
    totalEquipment: 150,
    availableStaff: 180,
    availableEquipment: 130,
    cardiacCases: 45,
    traumaCases: 38,
    medicalCases: 67,
    trafficCases: 52,
    otherCases: 33,
  };



  return (
    <div className="content-wrappers">
      <div className="content-header">
        {/* <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Dashboard</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">

              </ol>
            </div>
          </div>

        </div> */}
        {loading && (
          <div>
            <Spinner />
          </div>
        )}
        {!loading && (
          <div className="content">
            <div className="container-fluid">
              
            <GeneralStatistics
              dashboard={dashboard}
              iconSize={60}
            />
              <AmbulanceStatistics dashboard={dashboardData} />


              <Tabs value={currentTab} onChange={handleTabChange}>
                <Tab label="Figures" />
                <Tab label="Charts" />
              </Tabs>
              {currentTab === 0 && (
               
                <TripRevenueTab 
                dailyAcceptedTripRequestsCount={dailyAcceptedTripRequestsCount}
                currentTab={currentTab}
                dailyPendingTripRequestsCount={dailyPendingTripRequestsCount}
                dailyTripsCount={dailyTripsCount}
                dailySharedTripsCount={dailySharedTripsCount}
                dailyNewPassengersCount={dailyNewPassengersCount}
                dailyRevenue={dailyRevenue}
                weeklyRevenue={weeklyRevenue}
                monthlyRevenue={monthlyRevenue}
                yearlyRevenue={yearlyRevenue}
                trendingPickupLocations={trendingPickupLocations}
                trendingDestinationLocations={trendingDestinationLocations}
                iconSize={iconSize}

                />
              )}

              {currentTab === 1 && (
                // <TabPanel value={currentTab} index={1}>
                //   {/* Render the content for Passengers and Drivers tab here */}
                //   {/* Place the second section code here */}
                //   <div className="row">
                //     <div className="col-lg-6">
                //       <div className="card">
                //         <div className="card-header border-0">
                //           <div className="d-flex justify-content-between">
                //             <h3 className="card-title">Trips By Date</h3>
                //           </div>
                //         </div>
                //         <div className="card-body">
                //           <Line
                //             width={"400px"}
                //             height={"300px"}
                //             data={tripsByMonthData}
                //             options={{
                //               title: {
                //                 display: true,
                //                 // text:'Average Rainfall per month',
                //                 fontSize: 20,
                //               },
                //               maintainAspectRatio: false,
                //               legend: {
                //                 display: true,
                //                 position: "right",
                //               },
                //             }}
                //           />
                //           <div></div>
                //         </div>
                //       </div>
                //     </div>
                //     <div className="col-lg-6">
                //       <div className="card">
                //         <div className="card-header border-0">
                //           <div className="d-flex justify-content-between">
                //             <h3 className="card-title">Revenues By Date</h3>
                //           </div>
                //         </div>
                //         <div className="card-body">
                //           <Line
                //             width={"400px"}
                //             height={"300px"}
                //             data={revenuesByMonthData}
                //             options={{
                //               title: {
                //                 display: true,
                //                 fontSize: 20,
                //               },
                //               maintainAspectRatio: false,
                //               legend: {
                //                 display: true,
                //                 position: "right",
                //               },
                //             }}
                //           />
                //           <div></div>
                //         </div>
                //       </div>
                //     </div>
                //   </div>

                //   <div className="row">
                //     <div className="col-lg-6">
                //       <div className="card">
                //         <div className="card-header border-0">
                //           <div className="d-flex justify-content-between">
                //             <h3 className="card-title">Passengers By Month</h3>
                //           </div>
                //         </div>
                //         <div className="card-body">
                //           <div style={{ height: "400px", width: "600px" }}>
                //             <Bar
                //               data={passengersByMonthData}
                //               options={{
                //                 maintainAspectRatio: false,
                //                 responsive: true,
                //                 title: {
                //                   display: true,
                //                   text: "Passengers by Month",
                //                   fontSize: 24,
                //                   fontColor: "#333",
                //                 },
                //                 legend: {
                //                   display: true,
                //                   position: "bottom",
                //                   labels: {
                //                     fontColor: "#333",
                //                     fontSize: 14,
                //                     boxWidth: 12,
                //                   },
                //                 },
                //                 scales: {
                //                   xAxes: [
                //                     {
                //                       gridLines: {
                //                         display: false,
                //                       },
                //                       ticks: {
                //                         fontColor: "#333",
                //                       },
                //                     },
                //                   ],
                //                   yAxes: [
                //                     {
                //                       gridLines: {
                //                         color: "#EEE",
                //                         borderDash: [2, 2],
                //                         zeroLineColor: "#EEE",
                //                         zeroLineBorderDash: [2, 2],
                //                       },
                //                       ticks: {
                //                         beginAtZero: true,
                //                         fontColor: "#333",
                //                       },
                //                     },
                //                   ],
                //                 },
                //               }}
                //             />
                //           </div>
                //         </div>
                //       </div>
                //     </div>
                //     <div className="col-lg-6">
                //       <div className="card">
                //         <div className="card-header border-0">
                //           <div className="d-flex justify-content-between">
                //             <h3 className="card-title">Drivers By Month</h3>
                //           </div>
                //         </div>
                //         <div className="card-body">
                //           <Bar
                //             data={driversByMonthData}
                //             options={{
                //               title: {
                //                 display: true,
                //                 // text:'Average Rainfall per month',
                //                 fontSize: 20,
                //               },
                //               legend: {
                //                 display: true,
                //                 position: "right",
                //               },
                //             }}
                //           />
                //         </div>
                //       </div>
                //     </div>

                //     <div className="col-lg-6">
                //       <div className="card">
                //         <div className="card-header border-0">
                //           <div className="d-flex justify-content-between">
                //             <h3 className="card-title">
                //               Drivers Registration Statistics
                //             </h3>
                //           </div>
                //         </div>
                //         <div className="card-body">
                //           <Bar
                //             data={driversByRegistrationData}
                //             options={{
                //               title: {
                //                 display: true,
                //                 text: "Data",
                //                 fontSize: 20,
                //               },
                //               legend: {
                //                 display: true,
                //                 position: "right",
                //               },
                //             }}
                //           />
                //         </div>
                //       </div>
                //     </div>
                //   </div>
                // </TabPanel>
                <PassengerDriverTab 
                currentTab={currentTab}
                tripsByMonthData={tripsByMonthData}
                revenuesByMonthData={revenuesByMonthData}
                passengersByMonthData={passengersByMonthData}
                driversByMonthData={driversByMonthData}
                driversByRegistrationData={driversByRegistrationData}


                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};


export default Dashboard;


